import React, { FC, Fragment, useEffect, useState } from "react";
import {
  ActionBtn,
  FormBody,
  FormContainer,
  FormWrapper,
  HeaderView,
  ImageSection,
  SectionTitle,
  SectionWrapper,
} from "./styleCreateCoin";
import ViewHeader from "../../components/ViewHeader/ViewHeader";
import { adminRouts } from "../../routs";
import FormBuilder from "../FormBuilder/FormBuilder";
import {
  FormElement,
  FormElementType,
  InputTypes,
  InputVariant,
  NotificationType,
  customValidationType,
} from "../../Utility/InterFacesAndEnum";
import { emptyFormState, updateFormInputState } from "../../Utility/Utility";
import CoinImageUploader from "../../components/ImageUploader/CoinImageUploader";
import CoinThumbnailUploader from "../../components/ImageUploader/CoinThumbnailUploader";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../app/Store";
import Button from "../../components/UI/Button/Button";
import { nanoid } from "@reduxjs/toolkit";
import { toggleNotificationVisibility } from "../../features/networkNotification";
import { validateCreateCoin } from "../../Utility/formValidation";
import { createCoin } from "../../features/coinSlice";
import { useNavigate } from "react-router-dom";

interface FormState {
  form: FormElement[];
  isValidForm: boolean;
}

enum ButtonSize {
  sm = "small",
  md = "medium",
  lg = "large",
}
enum ButtonVariant {
  primaryFilled = "primary-filled",
  secondary = "secondary",
  primaryLink = "primaryLink",
}

const CoinDetails: FormState = {
  form: [
    {
      elementType: FormElementType.input,
      value: "",
      id: "coinTitle",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: true,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.text,
      customValidationType: customValidationType.titleValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "Title",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: false,
    },
    {
      elementType: FormElementType.textArea,
      value: "",
      id: "coinDescription",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: true,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.text,
      customValidationType: customValidationType.descriptionValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "Description",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: false,
    },
    {
      elementType: FormElementType.input,
      value: "",
      id: "coinPrice",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: true,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.number,
      customValidationType: customValidationType.priceValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "Coin Price",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: false,
    },
  ],
  isValidForm: true,
};
const CreateCoin: FC = () => {
  const dispatch = useDispatch();
  const { thumbnail, thumbnailName, images, imageNames } = useSelector(
    (state: RootState) => state.images
  );
  const isNavigate = useSelector((state: RootState) => state.coin.isNavigate);
  const navigate = useNavigate();
  const [coinDetail, setCoinDetail] = useState<FormState>(CoinDetails);
  // const coinId = Math.floor(Math.random() * 90000) + 10000;

  useEffect(() => {
    // console.log(isNavigate)
    if (isNavigate) {
      navigate(adminRouts.coinList);
    }
  }, [isNavigate]);
  const handleCoinInputChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ): void => {
    let updatedStateArray = updateFormInputState(event, coinDetail.form);
    setCoinDetail({
      ...coinDetail,
      form: updatedStateArray,
    });
  };
  const createCoinView = (
    <FormBuilder
      formElements={coinDetail.form}
      onInputChange={handleCoinInputChange}
      onSelectValueChange={() => {}}
      onChangeDate={() => {}}
      onChangeTime={() => {}}
    />
  );
  const validateForm = () => {
    let formElementArray = [...coinDetail.form];
    let requestObj: any = {};
    for (let formElement of formElementArray) {
      requestObj[formElement.id] = formElement.value;
    }
    // requestObj['coinId']=coinId;
    requestObj["coinThumbnailImage"] = thumbnailName[0];
    requestObj["coinImages"] = imageNames;

    let validateObj = validateCreateCoin(requestObj);
    if (validateObj.status) {
      if (
        thumbnail !== undefined &&
        thumbnail !== null &&
        thumbnail.length === 0
      ) {
        dispatch(
          toggleNotificationVisibility({
            isVisible: true,
            status: NotificationType.error,
            message: "Please upload coin thumbnail.",
          })
        );
        return;
      }
      if (images !== undefined && images !== null && images.length === 0) {
        dispatch(
          toggleNotificationVisibility({
            isVisible: true,
            status: NotificationType.error,
            message: "Please upload coin images.",
          })
        );
        return;
      }

      // console.log(requestObj)
      dispatch(createCoin(requestObj));
      emptyFormState(coinDetail);
    } else {
      dispatch(
        toggleNotificationVisibility({
          isVisible: true,
          status: NotificationType.error,
          message: validateObj.message,
        })
      );
    }
  };

  return (
    <Fragment>
      <HeaderView>
        <ViewHeader
          title={"Create Coin"}
          isBackButtonRequired={true}
          backButtonRedirectionUrl={adminRouts.coinList}
        />
      </HeaderView>
      <FormContainer>
        <SectionWrapper>
          <FormWrapper>
            <SectionTitle>Create Coin</SectionTitle>
            <FormBody>{createCoinView}</FormBody>
          </FormWrapper>
        </SectionWrapper>
        <ImageSection>
          <div style={{ marginTop: "10px", width: "100%" }}>
            <CoinThumbnailUploader isShowBtn={true} isLottery={false} />
          </div>
          <CoinImageUploader isShowBtn={true} />
        </ImageSection>
      </FormContainer>

      <ActionBtn>
        <Button
          title={"Create Coin"}
          btnSize={ButtonSize.md}
          btnVariant={ButtonVariant.primaryFilled}
          clicked={validateForm}
        />
      </ActionBtn>
    </Fragment>
  );
};

export default CreateCoin;
